import FilterSection from '@client/components/search/FilterSection';
import { RESEEDING_FILTER_CONFIGS, DOCUMENT_TYPE } from '@client/feature/treatment/config/filterConfigs';

const Reseeding = ({ filters, onFilterChange, aggregations, filterLabels }) => {
  return (
    <FilterSection
      filterConfigs={RESEEDING_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
      aggregations={aggregations}
      className="grid grid-cols-1 gap-4 sm:grid-cols-4"
      filterLabels={filterLabels}
    />
  );
};

export default Reseeding;
